import { ErrorScreen } from '@/components/shared/error-screen'

export function NotFoundPage() {
  return (
    <ErrorScreen
      code={404}
      title="This line’s gone dead."
      message="That page doesn’t exist, or has moved."
      to="/dashboard"
      action="Go to the dashboard"
    />
  )
}
